import { api } from '../../../../api/axiosInstance';
import { AuthRepository } from '../../Domain/Repositories/AuthRepository';
import { AuthTokens, SlotOpsOverrideResult, User } from '../../Model/User';

export class AuthRepositoryImpl implements AuthRepository {
  /* 로그인 */
  login(username: string, password: string): Promise<AuthTokens> {
    return api
      .post<AuthTokens>(
        '/auth/login/',                     // POST /auth/login
        { username, password },
        { headers: { 'Content-Type': 'application/json' } },
      )
      .then(r => r.data);
  }

  /* GET /auth/me  (access 토큰은 인터셉터가 자동 주입) */
  me(): Promise<User> {
    return api.get<User>('/auth/me').then(r => r.data);
  }

  /* POST /auth/refresh  { refresh } */
  refresh(refresh: string): Promise<{ access: string }> {
    return api
      .post<{ access: string }>(
        '/auth/refresh/',
        { refresh },
        { headers: { 'Content-Type': 'application/json' } },
      )
      .then(r => r.data);
  }

  activateSlotOpsOverride(password: string): Promise<SlotOpsOverrideResult> {
    return api
      .post<SlotOpsOverrideResult>(
        '/auth/slot-ops-override/',
        { password },
        { headers: { 'Content-Type': 'application/json' } },
      )
      .then(r => r.data);
  }
}
